import * as React from 'react';

import { IconButton } from '@coursera/cds-core';

import CurriculumEnrollmentWarningModal from 'bundles/internal-enterprise/components/CurriculumEnrollmentWarningModal';

type Props = {
  course: { id: string; name: string; slug: string };
  enrolled: boolean;
  s12nSlugs: Array<string>;
  programId: string;
  userId: string;
};

type State = {
  showEnrollModal: boolean;
};

class CourseRow extends React.Component<Props, State> {
  state = {
    showEnrollModal: false,
  };

  openEnrollModal = () => {
    this.setState({ showEnrollModal: true });
  };

  closeEnrollModal = () => {
    this.setState({ showEnrollModal: false });
  };

  render() {
    const { course, enrolled, s12nSlugs, programId, userId } = this.props;
    return (
      <div className="row">
        <div className="table-cell col-xs-3">{course.name}</div>
        <div className="table-cell col-xs-2">{course.slug}</div>
        <div className="table-cell col-xs-2">{course.id}</div>
        <div className="table-cell col-xs-2">{s12nSlugs.length > 0 ? s12nSlugs.join(', ') : 'None'}</div>
        <div className="table-cell col-xs-2">{enrolled ? 'ENROLLED' : 'NOT ENROLLED'}</div>
        <div className="table-cell col-xs-1">
          {!enrolled && (
            <IconButton intent="add" tooltip="Enroll in course" variant="ghost" onClick={this.openEnrollModal} />
          )}
        </div>
        {this.state.showEnrollModal && (
          <CurriculumEnrollmentWarningModal
            onClosed={this.closeEnrollModal}
            enrollType="enrollInCourse"
            programId={programId}
            item={course}
            userId={userId}
          />
        )}
      </div>
    );
  }
}

export default CourseRow;
